const MULTILINGUAL_RESOURCES = {
  banner: { static: 2, dynamic: 3 },
  product: { static: 2, dynamic: 3 },
  'category-with-products': { static: 3, dynamic: 4 },
  category: { static: 2, dynamic: 3 },
  'menu-products': { static: 3, dynamic: 4 },
  'auto-add-product': { static: 3, dynamic: 4 },
  popup: { static: 3, dynamic: 4 },
  combo: { static: 2, dynamic: 3 },
  modifier: { static: 2, dynamic: 3 },
  'news-events': { static: 2, dynamic: 3 },
  promo: { static: 2, dynamic: 3 },
  vacancy: { static: 2, dynamic: 3 },
  tags: { static: 1, dynamic: 2 },
  story: { static: 1, dynamic: 2 },
  'discount-with-order-price': { static: 3, dynamic: 4 },
  'discount-with-all': { static: 2, dynamic: 3 },
  'discount-with-products': { static: 2, dynamic: 3 },
  recommended_products: { static: 2, dynamic: 3 },
  'product-favourites': { static: 2, dynamic: 3 },
  // Customer API has no /v2/website-settings or /v2/seo routes yet (404 page not found).
  // Keep on v1; bump dynamic when backend registers them.
  'website-settings': { static: 1, dynamic: 1 },
  seo: { static: 1, dynamic: 1 },
  'seo-by-domain': { static: 1, dynamic: 1 },
  'static-page': { static: 1, dynamic: 2 },
  // Keep on v1 for both modes; do not bump with dynamic language.
  'user_reviews': { static: 1, dynamic: 1 },
  // Customer API has no /v3/review-settings yet; keep on v2 for both modes.
  'review-settings': { static: 2, dynamic: 2 },
  'referral-programs': { static: 1, dynamic: 1 },
  check_point_delivery_zones: { static: 1, dynamic: 2 },
  'active-delivery-zones': { static: 2, dynamic: 3 },
  branches: { static: 1, dynamic: 2 },
  'check-available-tables': { static: 1, dynamic: 2 },
} as const

export type MultilingualResource = keyof typeof MULTILINGUAL_RESOURCES

export function getApiVersion(
  resource: MultilingualResource,
  useDynamicLanguage: boolean
): number {
  const versions = MULTILINGUAL_RESOURCES[resource]
  return useDynamicLanguage ? versions.dynamic : versions.static
}

export function apiPath(
  resource: MultilingualResource,
  useDynamicLanguage: boolean
): string {
  const version = getApiVersion(resource, useDynamicLanguage)
  return `/v${version}/${resource}`
}

export function buildApiUrl(
  resource: MultilingualResource,
  useDynamicLanguage: boolean,
  suffix = ''
): string {
  const path = apiPath(resource, useDynamicLanguage)
  return suffix ? `${path}/${suffix}` : path
}
